import { Image, type ImageProps } from "@chakra-ui/react";
import { type UnifiedTokenBalance, isMultichainToken } from "@umami/chains";

type TokenIconProps = {
  token: UnifiedTokenBalance;
} & ImageProps;

export const TokenIcon = ({ token, ...props }: TokenIconProps) => {
  const url = isMultichainToken(token)
    ? token.iconUrl
    : `https://services.tzkt.io/v1/avatars/${token.contract}`;

  return <Image fallbackSrc="./static/coin-front.svg" src={url} {...props} />;
};
